import React from "react";
import { useHistory } from "react-router-dom";

const CatItem = ({ category, cid, count }) => {
  const history = useHistory();
  let atCat = history.location.pathname === `/dashboard/category/${cid}`;
  return (
    <div
      onClick={() => {
        history.push(`/dashboard/category/${cid}`);
      }}
      className={`mt-4 cursor-pointer flex flex-row items-center h-12 px-4 rounded-lg text-gray-600  hover:bg-gray-100 ${
        atCat ? "bg-gray-100" : "bg-white"
      }`}
    >
      <span className='flex items-center justify-center text-lg text-gray-500'>
        <svg
          className='w-6 h-6'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
          />
        </svg>
      </span>
      <span className='ml-3'>{category}</span>
      <span className='flex items-center justify-center text-sm text-gray-500 font-semibold bg-gray-200 h-6 px-2 rounded-full ml-auto'>
        {count}
      </span>
    </div>
  );
};

export default CatItem;
